import { adminServiceUrl } from "../Config/config";
import { toast, Slide } from "react-toastify";
import axios from "axios";
import CustomToast from "../../components/Toast";
import { RxThickArrowUp } from "react-icons/rx";
import moment from 'moment-timezone';


let currentIndex = 0;

export const showToast = (message, type = "error", customAutoCloseTime) => {
  if (!message) {
    console.log("No message provided.");
    return;
  }

  let displayMessage = "";

  // ✅ HANDLE AXIOS ERROR OBJECT
  if (typeof message === "object") {
    if (message?.response) {
      const status = message.response.status;

      if (status === 422) {
        const apiMsg =
          message.response.data?.message ||
          message.response.data?.error;

        const apiErrors = message.response.data?.errors;

        if (apiErrors) {
          const firstError = Object.values(apiErrors)[0]?.[0];
          displayMessage = firstError || apiMsg || "Validation error";
        } else {
          displayMessage = apiMsg || "Validation error";
        }
      } else {
        displayMessage =
          message.response.data?.message ||
          message.response.data?.error ||
          "Something went wrong";
      }
    } else if (message?.request) {
      displayMessage = "Network error. Please check your internet.";
    } else {
      displayMessage = message.message || "Something went wrong";
    }
  } else {
    // ✅ NORMAL STRING MESSAGE
    displayMessage = message;
  }

  // ✅ NOW messageArray IS DECLARED AFTER displayMessage
  const messageArray = displayMessage
    .split(/[\.,\n]/)
    .map(item => item.trim())
    .filter(item => item.length > 0);

  if (messageArray.length === 0) {
    console.log("No valid messages to show.");
    return;
  }

  const autoCloseDuration = customAutoCloseTime || 5000;

  if (currentIndex < messageArray.length) {
    const currentMessage = messageArray[currentIndex];
    const uniqueToastId = `toast-${Date.now()}-${Math.random()}`;

    toast(
      <CustomToast
        message={currentMessage}
        type={type}
        toastId={uniqueToastId}
        autoCloseTime={autoCloseDuration}
      />,
      {
        autoClose: autoCloseDuration,
        hideProgressBar: true,
        closeButton: false,
        toastId: uniqueToastId,
        transition: Slide,
      }
    );

    currentIndex++;
  }

  if (currentIndex >= messageArray.length) {
    currentIndex = 0;
  }
};




export const handleLogin = async ({ email, password }) => {
  try {
    const response = await axios.post(
      `${adminServiceUrl}/login`,
      { email, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const handleUpdatepassword = async ({ current_password, password, confirm_password }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/change-password`,
      { current_password, password, confirm_password },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const handleUpdateProfile = async ({ first_name, last_name, email }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-profile`,
      { first_name, last_name, email },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const Authme = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/authme`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      window.location.href = "/"
    } else {
      throw error.response ? error.response.data : error;
    }
  }
}

export const DashbaordInfo = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/dashboard`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const handleLenderlist = async ({
  type,
  active_status,
  limit = 10,
  offset = 0,
  token, search
}) => {
  try {
    const requestBody = {
      limit,
      offset,
      search
    };

    if (type) requestBody.type = type;
    if (active_status) requestBody.active_status = active_status;

    const response = await axios.post(
      `${adminServiceUrl}/lenders-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {

    throw error.response ? error.response.data : error;

  }
};


export const handleRaiserlist = async ({
  type,
  active_status,
  limit = 10,
  offset = 0,
  token, search
}) => {
  try {
    const requestBody = {
      limit,
      offset, search
    };

    if (type) requestBody.type = type;
    if (active_status) requestBody.active_status = active_status;

    const response = await axios.post(
      `${adminServiceUrl}/raisers-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const handleProjectlist = async ({
  type,
  limit = 10,
  offset = 0,
  token, search
}) => {
  try {
    const requestBody = {
      limit,
      offset, search,
      ...(type !== "" && { funding_status: type }),
    };
    const response = await axios.post(
      `${adminServiceUrl}/get-projects-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const handleFundsecurelist = async ({
  limit = 10,
  offset = 0,
  token,
}) => {
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/funding-secured-projects-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const UserdetailsInfo = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/user-details/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error)
    throw error.response ? error.response.data : error;
  }
}

export const ProjectdetailsInfo = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/project-details/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error)
    throw error.response ? error.response.data : error;
  }
}

export const Analyticsdata = async (type, userType, count) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/users-analytics-data`,
      {
        type,
        userType,
        count
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const ProjectAnalyticsdata = async (type, count) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/project-analytics-data`,
      {
        type,
        count
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const InterestedUserAnalyticsdata = async (type, count) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/project-interested-user-analytics`,
      {
        type,
        count
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const MatchedUserAnalyticsdata = async (type, count) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/matched-user-analytics`,
      {
        type,
        count
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}


export const handleExportLenderlist = async ({ type, active_status }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      type: type || "",
      active_status: active_status || "",
    };

    const response = await axios.post(
      `${adminServiceUrl}/export-lenders-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const handleExportRaiserlist = async ({ type, active_status }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      type: type || "",
      active_status: active_status || "",
    };

    const response = await axios.post(
      `${adminServiceUrl}/export-raisers-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const handleNewDealsList = async ({ type, project_scope, amount, sortBy = "created_at", order = "desc", limit = 10, offset = 0 }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      type: type || "",
      project_scope: project_scope || "",
      amount: amount,
      sortBy,
      order,
      limit,
      offset
    };

    const response = await axios.post(
      `${adminServiceUrl}/new-posted-deals`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const InterestedUsers = async ({ limit = 10, offset = 0 }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset
    };

    const response = await axios.post(
      `${adminServiceUrl}/project-interested-users`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const MarkAsClosed = async (id, closed_at) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/mark-project-closed/${id}`, { closed_at }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const RetryProjectCommissionCharge = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/retry-project-commission-charge/${id}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const MarkAsCompleted = async (id, completed_at) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/mark-project-completed/${id}`, { completed_at }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const handleExportProjectlist = async ({ funding_status }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      "funding_status": funding_status
    };

    const response = await axios.post(
      `${adminServiceUrl}/export-projects-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );
    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const newMatchesApi = async (req) => {
  // console.log(req, token)
  try {
    const response = await axios.post(`${adminServiceUrl}/new-matches-created`, req, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}


export const dealsMarkedApi = async ({
  limit = 10,
  offset = 0,
  token,
}) => {
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/deals-marked`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const exportDealsMarked = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/export-deals-marked`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const exportNewMatched = async (req) => {
  let token = localStorage.getItem("token")
  try {


    const response = await axios.post(
      `${adminServiceUrl}/export-new-matches-created`, req,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};



// "How did you hear about Stride Capital?" — keys match the mobile referral page
// and the Joi validation in authUserService.
export const REFERRAL_SOURCE_LABELS = {
  friend: "Friend or colleague",
  social_media: "Social media",
  search: "Google or web search",
  app_store: "App Store / Google Play",
  event: "Real estate event or meetup",
  other: "Other",
};

export const formatReferralSource = (about) => {
  const source = about?.referral_source;
  if (!source) return "";
  const label = REFERRAL_SOURCE_LABELS[source] || source;
  return about?.referral_source_other
    ? `${label}: ${about.referral_source_other}`
    : label;
};

export const usTimezone = (time) => {
  var timezone = moment(time).tz('America/New_York').format('MM/DD/YYYY hh:mm A')
  return timezone;
}

export const exportInterestedUsers = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/export-project-interested-users`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};

export const matchingConversionList = async (req) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/matching-to-funding-conversion`,
      req,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};


export const MatchingToFundingConversion = async (type, count) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(`${adminServiceUrl}/matching-to-funding-conversion-analytics`,
      {
        type,
        count
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}


export const handleExportMatching = async (req) => {
  let token = localStorage.getItem("token")
  try {

    const response = await axios.post(
      `${adminServiceUrl}/export-matching-to-funding-conversion`,
      req,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    return response.data;

  } catch (error) {
    console.error("Export error:", error);
    throw error.response?.data || error;
  }
};


export const markFundingSecured = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/mark-funding-secured/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}


export const removeSubscription = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/remove-subscription/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}


export const removeIdenfy = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${adminServiceUrl}/remove-idenfy-verification/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const deleteUsers = async (userids) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/delete-users`,
      { userids },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const handleBackgroundCheckList = async ({
  status,
  limit = 10,
  offset = 0,
  token, search
}) => {
  try {
    const requestBody = { limit, offset, search };
    if (status) requestBody.status = status;

    const response = await axios.post(
      `${adminServiceUrl}/background-check-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};

export const updateBackgroundCheckStatus = async (id, action) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/background-check/${id}`,
      { action },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}


export const allotSubscription = async (req, id) => {
  const data = {
    plan_key: req,
    userid: id
  }
  // console.log(req, token)
  try {
    const response = await axios.post(`${adminServiceUrl}/add-subscription`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}


export const VerifyIdenfy = async (id) => {
  try {
    const response = await axios.get(`${adminServiceUrl}/approve-idenfy-verification/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}


export const handleFreeTrials = async ({
  type,
  limit = 10,
  offset = 0,
  token, search
}) => {
  try {
    const requestBody = {
      limit,
      offset,
      status: type,
      search: search
    };
    const response = await axios.post(
      `${adminServiceUrl}/trial-subscription-users`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}


export const getNotifications = async ({
  limit = 10,
  offset = 0,
  token,
  search
}) => {
  try {
    const requestBody = {
      limit,
      offset,
      search
    };
    const response = await axios.post(
      `${adminServiceUrl}/get-push-notifications-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const fcmUsers = async () => {
  try {
    const response = await axios.get(`${adminServiceUrl}/fcm-token-users`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}


export const sendNoti = async ({ userids, title, body, image_url }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/create-and-send-push-notification`,
      { userids, title, body, image_url },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const resendNoti = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resend-push-notification/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const uploadImage = async (formdata) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/upload-file`,
      formdata,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};

export const deleteProject = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/delete-project/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const resetProjectFunding = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/reset-project-funding/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const uploadProjectToMultimodal = async (projectId) => {
  let token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${adminServiceUrl}/project/${projectId}/multimodal/upload`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getMultimodalStatus = async (projectId) => {
  let token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${adminServiceUrl}/project/${projectId}/multimodal/status`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getMultimodalDownloadUrl = async (executionId, downloadKey) => {
  let token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${adminServiceUrl}/multimodal/${executionId}/download/${downloadKey}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAdminList = async ({
  search = '',
  role = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset,
      role,
      search
    };
    const response = await axios.post(
      `${adminServiceUrl}/admins-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const updateAdminRole = async ({ id, value }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      admin_id: id,
      role: value
    };
    const response = await axios.post(
      `${adminServiceUrl}/change-admin-role`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createAdmin = async ({ first_name, last_name, email, password, role }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/create-admin`,
      { first_name, last_name, email, password, role },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteAdmin = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/delete-admin/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getTcPathwayList = async ({
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/tc-pathway-projects`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const getDealsAssigned = async ({
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/get-assigned-tc-pathways`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const updateTcStatus = async ({ id, value }) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      project_id: id,
      status: value
    };
    const response = await axios.post(
      `${adminServiceUrl}/tc-pathway/change-status`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getResources = async ({
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      search,
      limit,
      offset,
    };
    console.log("REQUEST BODY:", requestBody);
    const response = await axios.post(
      `${adminServiceUrl}/resources`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResource = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/add-resource`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const resourceDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResource = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-resource`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResource = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/delete-resource/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceCategories = async ({
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/categories`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceCategory = async ({
  body
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/add-category`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const resourceCategoryDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/category-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResourceCategory = async ({
  body
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-category`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResourceCategory = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/delete-category/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCategoryDropdown = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/get-categories`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceUsers = async ({
  resource_id,
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource/users-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceUser = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/add-user`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const resourceUserDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/user-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResourceUser = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/update-user`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResourceUser = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/delete-user/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceCompanies = async ({
  resource_id,
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource/companies-list`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceCompanies = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/add-company`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const resourceCompaniesDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/company-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResourceCompanies = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/update-company`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResourceCompanies = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/delete-company/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const markResourceHero = async ({
  resource_id,
  is_hero = 'true',
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_id,
      is_hero,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource/mark-as-hero`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getResourceVideo = async ({
  resource_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource/videos`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceVideo = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/add-video`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResourceVideos = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/delete-video/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const resourceVideoDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/video-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResourceVideo = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/update-video`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceChecklist = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/add-checklist`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const deleteResourceChecklist = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/delete-checklist/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceChecklist = async ({
  resource_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource/checklists`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const resourceChecklistDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource/checklist-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateResourceChecklist = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource/update-checklist`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getAnalytics = async ({
  reference_id,
  type,
  event,
  search = '',
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      reference_id,
      type,
      event,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/analytics`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getResourceUserVideo = async ({
  resource_user_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_user_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource-user/videos`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceUserVideo = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource-user/add-video`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const deleteResourceUserVideos = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource-user/delete-video/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceCompanyVideo = async ({
  resource_company_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_company_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource-company/videos`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceCompanyVideo = async ({
  formData
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource-company/add-video`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const deleteResourceCompanyVideos = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource-company/delete-video/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceUserButtons = async ({
  resource_user_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_user_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource-user/actions`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceUserButton = async ({
  body
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource-user/add-action`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const deleteResourceUserButton = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource-user/delete-action/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getResourceCompanyButtons = async ({
  resource_company_id,
  search,
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      resource_company_id,
      search,
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/resource-company/actions`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createResourceCompanyButton = async ({
  body
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/resource-company/add-action`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const deleteResourceCompanyButton = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/resource-company/delete-action/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getLenderNegativeRatings = async ({
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/negative-lender-ratings`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const getLenderPositiveRatings = async ({
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/positive-lender-ratings`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const updateLenderRatings = async (requestBody) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-lender-rating`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const approveLenderRating = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/approve-lender-rating/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const getBorrowerNegativeRatings = async ({
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/negative-borrower-ratings`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const getBorrowerPositiveRatings = async ({
  limit = 10,
  offset = 0,
}) => {
  let token = localStorage.getItem("token")
  try {
    const requestBody = {
      limit,
      offset,
    };
    const response = await axios.post(
      `${adminServiceUrl}/positive-borrower-ratings`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const updateBorrwerRatings = async (requestBody) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-borrower-rating`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const approveBorrowerRating = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/approve-borrower-rating/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const changeRole = async (id, role) => {
  const body = {
    userid: id,
    usertype: role
  }
  try {
    const response = await axios.post(`${adminServiceUrl}/change-user-type`,
      body,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
export const getBlogs = async ({
  search = '',
  page = 1,
  limit = 10,
  status = '',
}) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/blogs`,
      { search, page, limit, status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const createBlog = async ({ formData }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/add-blog`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const updateBlog = async ({ formData }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/update-blog`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}

export const blogDetail = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/blog-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteBlog = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(
      `${adminServiceUrl}/delete-blog/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const uploadBlogImage = async (formData) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${adminServiceUrl}/blog/upload-image`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error
  }
}
